/**
 * <s-map-consent data-src="https://..."> — two-click map embed. Nothing is loaded
 * from the map provider until the visitor presses the button inside the element;
 * the button is then replaced by the iframe.
 */
class SMapConsent extends HTMLElement {
  #ac;

  connectedCallback() {
    const button = this.querySelector('[data-map-load]');
    const src = this.dataset.src;
    if (!button || !src) return;

    this.#ac = new AbortController();
    button.addEventListener(
      'click',
      () => {
        const iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.title = this.dataset.title || '';
        iframe.loading = 'lazy';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.allowFullscreen = true;
        iframe.className = 'absolute inset-0 size-full border-0';
        this.querySelector('[data-map-placeholder]')?.remove();
        this.append(iframe);
        iframe.focus();
      },
      { signal: this.#ac.signal, once: true }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-map-consent')) customElements.define('s-map-consent', SMapConsent);
